module.exports = __webpack_public_path__ + "static/media/Gucci-White-Ace-Embroidered-Low-top-Sneaker-Lyst.6b4cfc70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Gucci-White-Ace-Embroidered-Low-top-Sneaker-Lyst.png
// module id = 304
// module chunks = 0